/**
 * useMyDataExportPort — port-factory hook returning a stable
 * {@link MyDataExportPort} adapter for production composition (033 US5, T041).
 *
 * The composer (`Composition`) calls this once at the root and passes the
 * instance through `PortsProvider` as the `myDataExport` slot. Like
 * `useAccountDeletionPort`, it constructs the REAL tRPC-backed adapter
 * (`TrpcMyDataExportAdapter` over `member.myData.export`) — the member's
 * cookie session authenticates the same-origin request, so no bearer source is
 * wired.
 *
 * Test harnesses (`renderAppWithPorts`) deliberately do NOT call this factory —
 * the `myDataExport` slot stays omitted by default so the missing-port stub
 * semantics hold; tests that exercise the export surface pass a fixture port
 * explicitly.
 *
 * Owned by feature 033-data-ownership-and-lifecycle-foundations.
 */

import { useState } from 'react';

import type { MyDataExportPort } from '../my-data/MyDataExportPort.js';
import { TrpcMyDataExportAdapter } from '../my-data/TrpcMyDataExportAdapter.js';
import { createWebTrpcClient } from '../trpc/client.js';

export function useMyDataExportPort(): MyDataExportPort {
  const [port] = useState<MyDataExportPort>(
    () => new TrpcMyDataExportAdapter(createWebTrpcClient()),
  );
  return port;
}
